import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useSiteData } from "@/context/SiteDataContext";
import { StarInput } from "./Stars";
import { PhotoPicker } from "./PhotoPicker";

const Field = ({ label, id, className = "", children }) => (
  <div className={`space-y-1.5 ${className}`}><Label htmlFor={id}>{label}</Label>{children}</div>
);

export const ReviewFields = ({ form, setForm, tid, onBusy }) => {
  const { packages } = useSiteData();
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const month = new Date().toISOString().slice(0, 7);
  return (
    <>
      <Field label="Your rating *" className="sm:col-span-2">
        <StarInput value={form.rating} onChange={(v) => setForm((f) => ({ ...f, rating: v }))} testPrefix={tid("rating")} />
      </Field>
      <Field label="Name *" id={tid("name")}>
        <Input id={tid("name")} required minLength={2} maxLength={80} value={form.name} onChange={set("name")} placeholder="e.g. Priya & Rahul" className="h-11" data-testid={tid("name-input")} />
      </Field>
      <Field label="City (optional)" id={tid("location")}>
        <Input id={tid("location")} maxLength={80} value={form.location} onChange={set("location")} placeholder="e.g. Bengaluru" className="h-11" data-testid={tid("location-input")} />
      </Field>
      <Field label="Package / trip (optional)" id={tid("trip")}>
        <Input id={tid("trip")} list={tid("trip-list")} maxLength={150} value={form.trip} onChange={set("trip")} placeholder="e.g. Honeymoon 4N/5D" className="h-11" data-testid={tid("trip-input")} />
        <datalist id={tid("trip-list")}>{packages.map((p) => <option key={p.id} value={p.name} />)}</datalist>
      </Field>
      <Field label="When did you travel? (optional)" id={tid("month")}>
        <Input id={tid("month")} type="month" max={month} value={form.travel_month} onChange={set("travel_month")} className="h-11" data-testid={tid("month-input")} />
      </Field>
      <Field label="Headline (optional)" id={tid("title")} className="sm:col-span-2">
        <Input id={tid("title")} maxLength={120} value={form.title} onChange={set("title")} placeholder="e.g. The best week of our lives" className="h-11" data-testid={tid("title-input")} />
      </Field>
      <Field label="Your review *" id={tid("text")} className="sm:col-span-2">
        <Textarea id={tid("text")} required minLength={10} maxLength={1500} rows={5} value={form.text} onChange={set("text")} placeholder="What did you love about the islands, hotels, ferries and our team?" data-testid={tid("text-input")} />
      </Field>
      <Field label={`Trip photos (up to 6) · ${form.photos.length}/6`} className="sm:col-span-2">
        <PhotoPicker value={form.photos} onChange={(photos) => setForm((f) => ({ ...f, photos }))} testPrefix={tid("upload")} onBusy={onBusy} />
      </Field>
    </>
  );
};
